export interface GetVersionResponse {
  version: string
}

export interface ClearDevLockResponse {
  message: string
}

export interface RevertAppResponse {}
